'use strict'
/**
 * ariaContext.js — Contrato CICATRIZ #3 (MACRO 1 · Ola 1).
 *
 * EL BUG QUE TIPA: las 5 páginas V2 llamaban auria?.setIsOpen?.(true)
 * cuando el context exponía openSheet — el optional chaining se tragó
 * el fallo EN SILENCIO en los 5 tabs y el companion entero estuvo
 * muerto sin un solo error (fix 542b471).
 *
 * PRODUCTOR: src/components/ai/AuriaContextProvider.jsx (value del Provider)
 * CONSUMIDOR: las 5 páginas V2 (hub, today, calendar, progress, dominios)
 *             + AuriaFAB + AuriaSheet
 *
 * El Provider valida su propio value contra este esquema al construirlo:
 * si un refactor elimina un método del contrato, el Provider lanza en el
 * acto — no 5 páginas mudas.
 */

const { z } = require('./z')

const fn = z.custom((v) => typeof v === 'function', { message: 'debe ser función' })

const AriaContextSchema = z
  .object({
    isOpen: z.boolean(),
    setIsOpen: fn,
    openSheet: fn,
    closeSheet: fn,
    setActiveCommand: fn,
    clearActiveCommand: fn,
    appendMessage: fn,
    setConversationHistory: fn,
    pendingContext: z.unknown().nullable(),
    activeCommand: z.unknown().nullable(),
    conversationHistory: z.array(z.unknown()),
    userId: z.string().nullable(),
  })
  .passthrough()

module.exports = { AriaContextSchema }
